import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
var defaultProps = {
    color: "default"
};
var Typography = function(_param) {
    var children = _param.children, className = _param.className, as = _param.as, variant = _param.variant, color = _param.color, props = _object_without_properties(_param, [
        "children",
        "className",
        "as",
        "variant",
        "color"
    ]);
    var style = variant !== null && variant !== void 0 ? variant : as === "h1" || as === "h2" || as === "h3" ? as : "default";
    var VARIANT_CLASSES = {
        none: "",
        h1: "lg:text-[2.5rem] lg:leading-[1.188em] font-quicksand font-bold text-[2.125rem] leading-[1.235em]",
        h2: "lg:text-[2.375rem] lg:leading-[1.25em] font-quicksand font-bold text-[1.688rem] leading-[1.259em]",
        h3: "lg:text-[1.75rem] lg:leading-[1.4em] font-quicksand font-bold text-[1.375rem] leading-[1.273em]",
        subtitle: "lg:text-[1.5rem] lg:leading-[1.3em] text-[1.313rem] leading-[1.238em] font-semibold",
        default: "lg:text-[1.125rem] lg:leading-[1.333em] text-[1.063rem] leading-[1.412em] font-semibold",
        body: "lg:text-[1.125rem] lg:leading-[1.778em] font-normal text-[1.063rem] leading-[1.588em]"
    }[style];
    var COLOR_CLASSES = {
        green: "text-color1",
        grey: "text-color7",
        default: "text-primary",
        white: "text-white",
        orange: "text-color3",
        error: "text-error",
        current: "text-current"
    }[color];
    var Component = as;
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
        className: clsx(VARIANT_CLASSES, COLOR_CLASSES, className),
        children: children
    }));
};
Typography.defaultProps = defaultProps;
export { Typography };
